import React from 'react';

import { clsx } from 'clsx';

export const InlineButton = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode;
  type?: 'reset' | 'button' | 'submit' | undefined;
} & React.HTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      type="button"
      {...props}
      className={clsx(
        'm-0 border-none bg-transparent p-0 text-primary-40 underline [font-size:inherit] hover:cursor-pointer',
        className,
      )}
    >
      {children}
    </button>
  );
};
